import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { hasModChanges } from "@src/store/slices/experienceBuilder/common/utils/hasModChanges";

export const hasBuilderChanges = createSelector(
  (state: RootState) => state.experienceBuilder.initialMods,
  (state: RootState) => state.experienceBuilder.mods,
  (initialMods, mods) => {
    if (initialMods.length !== mods.length) {
      return true;
    }

    for (const initialMod of initialMods) {
      const currentMod = mods.find((m) => m.id === initialMod.id);
      if (hasModChanges(initialMod, currentMod)) {
        return true;
      }
    }

    return false;
  }
);
